import React from 'react';
import { Typography, Button, Box, Chip } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import { ErrorIcon } from 'react-hot-toast';


interface SelectProps {
  value: string;
  onChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
  options: string[];
  label: string;
}

interface ScrapperHeaderProps {
  connected: boolean;
}

const ScraperHeader = (props: ScrapperHeaderProps) => {
  const {connected} = props;
  const scrappingWebsites = [
    'https://www.amazon.com/',
    'https://www.ebay.com/',
    'https://www.walmart.com/',
    'https://www.bestbuy.com/',
    'https://www.target.com/',
  ]
  return (
    <Box>
      <Box display={'flex'} flexDirection={'row'}>
        <Box display={'flex'} flexDirection={'column'}>
          <Box display={'flex'} flexDirection={'row'}>
            <Typography variant="h3" component="h3" gutterBottom>
              Scrapper UI
            </Typography>
            <Box>
              {connected ?
                (<Chip
                  sx={{ml: '5%'}}
                  color={'primary'}
                  label="Extension Connected"
                />) :
                (<Chip
                  sx={{ml: '5%'}}
                  color={'error'}
                  label="Not Connected"
                />)
              }
            </Box>
          </Box>
            <Typography variant="subtitle2">
              The status reflects if the Prizeet extension is connected or not.
            </Typography>
        </Box>

      </Box>
      <Box
        display="flex"
        flexDirection={'row'}
        sx={{
          width: { xs: '100%', sm: 'auto' }, // Full width on small screens, auto on larger
          minWidth: { sm: 400 }, // Minimum width of 400px on sm and up
          gap: 2, // Gap between child elements
          mt: { sm: 2 } // Margin top
        }}
      >

      </Box>
    </Box>
  );
};

export default ScraperHeader;
